import { FC } from 'react';
import styled from 'styled-components';
import AchievementBadge, { IAchievementBadge } from '../AchievementBadge/AchievementBadge';

const Container = styled.section`
  display: block;
  margin: 0 0 33px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dfdfdf;
`;

const Heading = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-family: ${type.face};
    font-size: ${type.size.regular};
    font-weight: ${type.weight.bold};
    line-height: 1.1875rem;
    text-transform: uppercase;
    margin: 0 0 21px;
    flex-shrink: 1;
    grid-column: 1;
    grid-row: 1;
  `;
});

const List = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  gap: 32px;
`;

const BadgeWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 16.66%;
  height: 115px;
`;

const AchievementBadgeList: FC<{ badges: IAchievementBadge[] }> = ({ badges }) => {
  const badgeLoop = badges.slice(0, 6).map((badge) => {
    return (
      <BadgeWrapper>
        <AchievementBadge {...badge} />
      </BadgeWrapper>
    );
  });

  return (
    <Container>
      <Heading>You've earned</Heading>
      {badgeLoop?.length <= 0 ? <div>No achievements yet! Keep playing to earn more!</div> : <List>{badgeLoop}</List>}
    </Container>
  );
};

export default AchievementBadgeList;
